declare namespace $ {

	export class $shm_dashboard_mentions extends $shm_ba_dashboard {
	}
	
}

//# sourceMappingURL=mentions.web.view.tree.d.ts.map